import angular from 'angular';
import {
  ssDialogService,
} from 'app/services';

import template from './preview-top-section-dialog.html';
import controller from './preview-top-section-dialog.controller';

class dialogService {
  getOptions($event, { sectionTitle, renderedHtml }) {
    return {
      controller,
      controllerAs: 'previewTopSectionDialogVM',
      locals: {
        sectionTitle,
        renderedHtml
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.previewTopSectionDialog', [
  ssDialogService,
])
  .service('previewTopSectionDialog', dialogService)
  .name;
